import { getUserProfileAsync } from "@chr/online-shared-microsite-core";

export function initFullStoryUser() {
  void getUserProfileAsync().then((profile) => {
    if (profile) {
      const userData = {
        displayName: profile.userId?.toString(),
        userName: profile.name,
        companyName: profile.primaryCustomerCode,
      };
      // eslint-disable-next-line no-unused-expressions, @typescript-eslint/no-unused-expressions
      profile.userId && FS.identify(profile.userId.toString(), userData);
    }
  });
}
